export default function AttributeSection ({attributes } ) { 
  const attributeContainerId = (attributeName) => {
    let attributeId = attributeName
      .toLowerCase()
      .replace("&", "and")
      .trim()
      .replace(/\s/g, "-");
    return `lexcms-attribute-${attributeId}`;
  };

return (

  <div className="lexcms-product-resources-attributes">

            {Object.keys(attributes || {}).map((attributeName, i) => {
              return (
                <div
                  key={i}
                  className="lexcms-product-attribute-container"
                  id={`${attributeContainerId(attributeName)}`}
                >
                  <h4 className="lexcms-product-attribute-heading">
                    {attributeName}
                  </h4>
                  <ul className="lexcms-product-attribute-list">
                    {attributes[attributeName].map((attr, i) => {
                      return (
                        <li key={i} className="lexcms-product-attribute-value">
                          {attr.display_value}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
)

}
